<div style="display: table-row;">
  <div
      [style]="{ 'padding-top': isAppointment ? '6px' :'12px', 'padding-bottom': isAppointment ? '6px' :'12px'}"
      style="display: table-cell; width: 564px; vertical-align: top;
  padding-left: 24px;
  padding-right: 8px;">
    <div class="left"
         *ngIf="type === 'tts' || (type !== 'tts' && uiText !== undefined)"
         [ngClass]="{ 'bubble-audiofile': (type !== 'tts' && uiText !== undefined),  'bubble-tts': type === 'tts'}"
         tooltip="(Sound: {{soundName}}, {{type === 'tts' ? 'tts' : 'soundid'}}: {{type === 'tts' ? ttsMessage : soundId}})">
      <table>
        <tr *ngIf="type === 'tts'">
          <td style="height: 44px; width: 12px; font-size: 36px; vertical-align: top;">“</td>
          <td>
            <div style="white-space: pre-wrap; font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                  font-size: 13px;
                  line-height: 24px;
                  max-width: 90%"
                 contenteditable=""
                 strip-br="true"
                 strip-newLine="true"
                 strip-html="true"
                 strip-nbsp="true"
                 [attr.contenteditable]="!isOnlyPreview"
                 [ng-model]="model"
                 id = "{{model}}"
                 [innerHtml]="(voiceMessage || '' ) | safe: 'html'"
                 style="width: 100%; overflow: hidden; overflow-x: auto; outline: none; border: none;
                 box-shadow: none; min-width: 300px; max-width: 500px;"
                 (click)="setSelectedNode($event)"
            >
            </div>
          </td>

          <td style="font-size: 36px; vertical-align: bottom">”</td>
        </tr>

        <tr *ngIf="type !== 'tts' && uiText !== undefined">
          <td [style]="{ 'height': isAppointment ? '28px' :'44px'}"
              style="width: 12px; vertical-align: top;"></td>
          <td [style]="{ 'font-size': isAppointment ? '11px' :'13px', 'line-height': isAppointment ? '18px' : '24px' }"
              style="font-family: Helvetica Neue,Helvetica,Arial,sans-serif;">

            <div style="white-space: pre-wrap; font-family: Helvetica Neue,Helvetica,Arial,sans-serif;
                font-size: 13px;
                line-height: 24px;
                max-width: 90%"
                 contenteditable="false"
                 strip-br="true"
                 strip-newLine="true"
                 strip-html="true"
                 strip-nbsp="true"
                 [attr.contenteditable]="!isOnlyPreview"
                 [ng-model]="model"
                 id = "{{model}}"
                 [innerHtml]="(uiText || '' ) | safe: 'html'"
                 style="width: 100%; overflow: hidden; overflow-x: auto; outline: none; border: none;
               box-shadow: none; min-width: 300px; max-width: 500px;"
                 (click)="setSelectedNode($event)"
                 *ngIf="uiText.indexOf('template-context') !== -1"
            >
            </div>
            <div *ngIf="uiText.indexOf('template-context') === -1">
              {{uiText}}
            </div>
          </td>
          <td style="font-size: 24px; vertical-align: bottom"></td>
        </tr>
      </table>

    </div>
  </div>
    <div style="display: table-cell; vertical-align: middle; width: 110px" *ngIf="type === 'tts' || (type !== 'tts' && uiText !== undefined)">

      <div style="display: table-row; border-style: solid" *ngIf="playerStatus$ | async as playerStatus">
        <div style="display: table-cell; vertical-align: middle;">
        </div>
        <div style="display: table-cell; vertical-align: middle; padding-left: 2px;" *ngIf="percentElapsed$ | async as headPOS">
        </div>
      </div>
  </div>
</div>
